import { Outlet, Route, Routes } from "react-router-dom";
import { NotFoundPage } from "../../Pages/NotFoundPage/NotFoundPage";
import { AzureVideo } from "../../Pages/azure/AzureVideo";
import HundredMs from "../../Pages/100ms/100ms";
import { LandingPage } from "../../Pages/LandingPage/LandingPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { DoctorProvider } from "../context/DoctorContext";
import { DoctorLogin } from "../../Screens/login_module/login";
import { DoctorDashboard } from "../../Screens/dashboard_module/dashboard";
import { DoctorConsultationActive } from "../../Screens/consultation_active_module/consultation_active";
import { DoctorClinicalNotes } from "../../Screens/clinical_notes_module/clinical_notes";
import { DoctorPrescription } from "../../Screens/prescription_module/prescription";
import { DoctorConsultationComplete } from "../../Screens/consultation_complete_module/consultation_complete";
import { DoctorConsultationDetail } from "../../Screens/consultation_detail_module/consultation_detail";
import { DoctorProfile } from "../../Screens/profile_module/profile";
import { DoctorHistory } from "../../Screens/history_module/history";
import { DoctorNotifications } from "../../Screens/notifications_module/notifications";
import { DoctorDocuments } from "../../Screens/documents_module/documents";

const DoctorLayout = () => (
  <DoctorProvider>
    <Outlet />
  </DoctorProvider>
);

export const MainRoutes = () => {
  return (
    <Routes>
      {/* Patient joins via WhatsApp link: AZURE_PLATFORM_URL/{jwt_token} */}
      <Route path="/:token" element={<LandingPage />} />
      {/* Legacy azure room page — kept for backward compat */}
      <Route path="azure/:roomId" element={<AzureVideo />} />
      <Route path="100ms/*" element={<HundredMs />} />
      <Route path="/" element={<DoctorLogin />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<DoctorLayout />}>
          <Route path="/dashboard" element={<DoctorDashboard />} />
          <Route path="/consultation/:id" element={<DoctorConsultationActive />} />
          <Route path="/consultation/:id/notes" element={<DoctorClinicalNotes />} />
          <Route path="/consultation/:id/prescription" element={<DoctorPrescription />} />
          <Route path="/consultation/:id/complete" element={<DoctorConsultationComplete />} />
          <Route path="/consultation/:id/detail" element={<DoctorConsultationDetail />} />
          <Route path="/profile" element={<DoctorProfile />} />
          <Route path="/history" element={<DoctorHistory />} />
          <Route path="/notifications" element={<DoctorNotifications />} />
          <Route path="/documents" element={<DoctorDocuments />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
